export const rowId = (index: number) => `search-row-${index}`
export const staticRowId = (index: number) => `search-static-row-${index}`
